import React from 'react'
import ImageCard from './ImageCard';
import { trackWindowScroll } from 'react-lazy-load-image-component';

const ImagesGrid = ({ scrollPosition }) => {
  const importAll = (r) => {
    let images = {};
    r.keys().forEach((item, index) => { images[item.replace('./', '')] = r(item); });
    return images;
  };
  
  const images = importAll(require.context('./images', false, /\.(png|jpe?g|svg|webp)$/))

  return (
    <div className='grid3 sectionSpacing'>
      {Object.keys(images).map((imageName, index) => (
        <ImageCard scrollPosition={scrollPosition} key={index} imageName={imageName} source={images[imageName]} />
      ))}
    </div>
  )
}

export default trackWindowScroll(ImagesGrid)